<template>
  <main-component />
</template>

<script>
import MainComponent from '@/components/UsersSeatingStatus/index'

export default {
  components: {
    MainComponent
  },

  data () {
    return {
      modelName: 'user/seatingStatus'
    }
  },

  async created () {
    this.$store.commit(`${this.modelName}/setAttr`, {
      name: 'userId',
      value: this.$route.params.id
    })
    this.$store.dispatch(`${this.modelName}/get`)
  }
}
</script>
